import React, { FC, useCallback, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'

import { Grid, Typography, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { getPossibleNextStatusesForCrm, TransactionStatusEnum } from '@sparling/financial-common'
import { InputSelect, IEnums } from '../../../../components/InputSelect'
import { InputField } from '../../../../components/InputField'
import { Modal } from '../../../../components/Modal'
import { useRefresh, useRest } from '../../../../components/Context'
import { resolver } from './resolver'
import { Loader } from '../../../../components/Loader'

const useStyles = makeStyles((theme: Theme) => ({
  modalInput: {
    width: 300,
    height: 140,
    textAlign: 'right',
  },
  modalItem: {
    marginTop: 17,
  },
  subtitle: {
    color: '#b2b3b5',
    fontWeight: 'normal',
    marginBottom: 8,
    fontSize: 14,
  },
  button: {
    paddingLeft: 15,
  },
  table: {
    paddingTop: theme.spacing(3),
  },
}))

interface IAddAsset {
  isOpen: boolean
  modalClose: () => void
  // eslint-disable-next-line
  singleData: any
}

type FormInputs = {
  status: string
}

const EditTransaction: FC<IAddAsset> = ({ isOpen, modalClose, singleData }) => {
  const formMethods = useForm<FormInputs>({
    mode: 'onBlur',
    resolver,
  })

  const { handleSubmit, reset } = formMethods
  const classes = useStyles()
  const { rxios } = useRest()
  const { saveIsRefresh } = useRefresh()
  const [loading, setLoading] = useState<boolean>(false)
  const [statusesEnum, setStatusesEnum] = useState<IEnums[]>([])

  const onSubmit = useCallback(
    // eslint-disable-next-line
    (data: any) => {
      setLoading(true)

      const pushData = {
        id: singleData.id,
        status: data.status,
        userId: singleData.userId,
        comment: data.comment || 'N/A',
      }

      if ([TransactionStatusEnum.INITIATED, TransactionStatusEnum.COMPLIANCE_MANUAL_CHECK].includes(data.status)) {
        rxios.put(`/transaction/`, pushData).subscribe(
          // eslint-disable-next-line
          (next: any) => {
            setLoading(false)
          },
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (error) => {
            setLoading(false)
            toast.error(error.response.data.message)
          },
          () => {
            toast.success('Transaction was signature')
            setLoading(false)
            modalClose()
            saveIsRefresh(true)
            formMethods.reset()
          },
        )
      }

      // else if (data.status === TransactionStatusEnum.SIGNED) {
      //   rxiosGeneral.post(`/trustology/user/transaction/${pushData.id}/sign`, pushData).subscribe(
      //     // eslint-disable-next-line
      //     (next: any) => {
      //       setLoading(false)
      //     },
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //     // @ts-ignore
      //     (error) => {
      //       setLoading(false)
      //       toast.error(error.response.data.message)
      //     },
      //     () => {
      //       toast.success('Transaction was signature')
      //       setLoading(false)
      //       modalClose()
      //       saveIsRefresh(true)
      //       formMethods.reset()
      //     },
      //   )
      // } else if (data.status === TransactionStatusEnum.REJECTED) {
      //   rxiosGeneral.post(`/trustology/user/transaction/${pushData.id}/cancel`, pushData).subscribe(
      //     // eslint-disable-next-line
      //     (next: any) => {
      //       setLoading(false)
      //     },
      //     // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //     // @ts-ignore
      //     (error) => {
      //       setLoading(false)
      //       toast.error(error.response.data.message)
      //     },
      //     () => {
      //       setLoading(false)
      //       toast.success('Transaction was rejected')
      //       modalClose()
      //       saveIsRefresh(true)
      //       formMethods.reset()
      //     },
      //   )
      // }
      else {
        rxios.put(`/transaction/`, pushData).subscribe(
          // eslint-disable-next-line
          (next: any) => {
            setLoading(false)
          },
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (error) => {
            setLoading(false)
            toast.error(error.response.data.message)
          },
          () => {
            setLoading(false)
            toast.success('Transaction was edited')
            modalClose()
            saveIsRefresh(true)
            formMethods.reset()
          },
        )
      }
    },
    // eslint-disable-next-line
    [singleData],
  )

  useEffect(() => {
    if (!isOpen) setTimeout(reset, 300)
    setLoading(false)
  }, [isOpen, reset])

  useEffect(() => {
    const statuses = singleData
      ? getPossibleNextStatusesForCrm(singleData.owner, singleData.status, singleData.type, singleData.riskScore)
      : []
    const array = []
    if (statuses) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const status of statuses) {
        array.push({
          value: status.status,
          label: status.label,
        })
      }
      setStatusesEnum(array)
    }
  }, [singleData])

  return (
    <Modal
      title="Transaction Status"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      submitTitle={'Confirm'}
      width={350}
    >
      {loading && <Loader />}
      <FormProvider {...formMethods}>
        <Grid container direction="column">
          <Grid item justifyContent="space-between" direction="column">
            <Typography variant="subtitle1" className={classes.subtitle}>
              Status
            </Typography>
            <InputSelect inputName="status" placeholder="Select" width={300} enums={statusesEnum} />
          </Grid>

          <Grid item justifyContent="space-between" direction="column" className={classes.modalItem}>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Comment
            </Typography>

            <div className={classes.modalInput}>
              <InputField inputName="comment" inputType="text" fullWidth rows={4} multiline />
            </div>
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}

export const MemoStatusesTransactions = React.memo(EditTransaction)
